import type { DroneNameMap } from '../../types';

// Resolves a battery's used-with drone ids to display names, dropping any
// unknown ids. Returns names in the order the ids appear on the battery.
export const getUsedWithNames = ({
    droneIds,
    droneNames
}: {
    droneIds: string[];
    droneNames: DroneNameMap;
}): string[] =>
    droneIds.map(droneId => droneNames[droneId]).filter((name): name is string => Boolean(name));
